import { ELEMENT_TYPE } from '../config/constants';
import moments from './moments';
import products from './products';
import designers from './designers';
import rooms from './rooms';
import translations from './index';

const { general, humanNames, humanTitle, momentTitle } = translations;

export default [
  {
    type: ELEMENT_TYPE.DUMMY,
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1919',
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV02',
    name: momentTitle.EV02,
    year: '1919',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/moments/Braun_MaxBraun_Hero_Braun__Bauhaus_1919_Thumb.jpg',
    data: moments.EV02,
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1921',
  },
  {
    id: 'HD01',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD01,
    position: humanTitle.HD01,
    name: humanNames.HD01,
    between: [1921, 1951],
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__MaxBraun_1921_Thumb.jpg',
  },
  {
    id: 'PR01',
    data: products.PR01,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Transmission belt',
    year: '1921',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1597909256/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Joining_system_for_transmission_belt_1921_Thumb_Big.png',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR02',
        data: products.PR02,
        name: 'Cosmophon 333W',
        year: '1932',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Cosmophon_333W_1932_Thumb_Big.jpg',
      },
      {
        id: 'PR03',
        data: products.PR03,
        name: 'Cosmophon 777C',
        year: '1934',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Combination_Radio_Phonograph_1934_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.ROOM_PREVIEW,
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_450/max-braun/rooms/room2040.jpg',
    url: '/timeline/roomInteraction/2040',
    id: '2040',
    data: rooms['2040'],
    roomPreviewId: '2040',
  },
  {
    type: ELEMENT_TYPE.ROOM,
    label: general.roomExplorer,
    action: general.tapToExplore,
    year: '1921',
    id: 'ROOM_2040',
  },
  {
    id: 'PR04',
    data: products.PR04,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Manulux',
    year: '1938',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1597909256/max-braun/timeline/products/Braun_MaxBraun_Timeline_Manalux_Thumb_Big.png',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1944',
  },
  {
    id: 'PR05',
    data: products.PR05,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'S 50',
    year: '1950',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_S50_1950_Thumb_Big.jpg',
  },
  {
    id: 'HD02',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD02,
    position: humanTitle.HD02,
    name: humanNames.HD02,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__A_E_Braun_1951_Thumb.jpg',
    between: [1951, 1967],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1952',
  },
  {
    id: 'HD03',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD03,
    position: humanTitle.HD03,
    name: humanNames.HD03,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__WolfgangSchmittel_1952_Thumb.jpg',
    between: [1952, 1980],
  },
  {
    id: 'HD04',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD04,
    position: humanTitle.HD04,
    name: humanNames.HD04,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__DrFritzEichler_1951_Thumb.jpg',
    between: [1953, 1978],
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV03',
    name: momentTitle.EV03,
    year: '1952',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/moments/Braun-logo-black.svg.jpg',
    data: moments.EV03,
  },
  {
    id: 'PR06',
    data: products.PR06,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Multimix Blender',
    year: '1953',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Multimix_Blender_1953_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV04',
    name: momentTitle.EV04,
    year: '1953',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/moments/Braun_MaxBraun_Hero_Braun__Ulm_1953_Thumb.jpg',
    data: moments.EV04,
  },
  {
    id: 'HD05',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD05,
    position: humanTitle.HD05,
    name: humanNames.HD05,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__WilhelmWagenfeld_1954_Thumb.jpg',
    between: [1954, 1958],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1954',
  },
  {
    id: 'PR07',
    data: products.PR07,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Smoothy',
    year: '1954',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Smoothy_1954_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV05',
    name: momentTitle.EV05,
    year: '1955',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/moments/Braun_MaxBraun_Hero_Braun__RadioExhibition_1955_Thumb.jpg',
    data: moments.EV05,
  },
  {
    id: 'HD06',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD06,
    position: humanTitle.HD06,
    name: humanNames.HD06,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__OtlAicher_1955_Thumb.jpg',
    between: [1955, 1958],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR08',
        data: products.PR08,
        name: 'Braun Combi',
        year: '1955',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Combi_1955_Thumb_Big.jpg',
      },
      {
        id: 'PR09',
        data: products.PR09,
        name: 'SK 1',
        year: '1955',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_SK1_1955_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR11',
        data: products.PR11,
        name: 'G 11',
        year: '1955',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_G11_1955_Thumb_Big.jpg',
      },
      {
        id: 'PR10',
        data: products.PR10,
        name: 'FS-G',
        year: '1955',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_FS-G_1955_Thumb_Big.jpg',
      },
    ],
  },
  {
    id: 'HD07',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD07,
    position: humanTitle.HD07,
    name: humanNames.HD07,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__HansGugelot_1955_Thumb.jpg',
    between: [1955, 1964],
  },
  {
    id: 'HD08',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD08,
    position: humanTitle.HD08,
    name: humanNames.HD08,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__DieterRams_1955_Thumb.jpg',
    between: [1955, 1995],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1956',
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV06',
    name: momentTitle.EV06,
    year: '1956',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/moments/Braun_MaxBraun_Hero_Braun__BraunEames_1956_Thumb.jpg',
    data: moments.EV06,
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR12',
        data: products.PR12,
        name: 'SK 4',
        year: '1956',
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601466528/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_SK4_1956_Thumb_Big.jpg',
      },
      {
        id: 'PR13',
        data: products.PR13,
        name: 'KM 3/31',
        year: '1957',
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601466866/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_KM_3-31_1957_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.ROOM_PREVIEW,
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_450/max-braun/rooms/room5060.jpg',
    url: '/timeline/roomInteraction/5060',
    id: '5060',
    data: rooms['5060'],
    roomPreviewId: '5060_2',
  },
  {
    type: ELEMENT_TYPE.ROOM,
    label: general.roomExplorer,
    action: general.tapToExplore,
    year: '1956',
    url: '/timeline/roomInteraction/5060',
    id: 'ROOM_5060_2',
  },
  {
    id: 'PR14',
    data: products.PR14,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'T 3',
    year: '1958',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_T3_1958_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1958',
  },
  {
    id: 'HD09',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD09,
    position: humanTitle.HD09,
    name: humanNames.HD09,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__ReinholdWeiss_1959_Thumb.jpg',
    between: [1959, 1967],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR15',
        data: products.PR15,
        name: 'LE 1',
        year: '1959',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_LE1_1959_Thumb_Big.jpg',
      },
      {
        id: 'PR16',
        data: products.PR16,
        name: 'TP 1',
        year: '1959',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_TP1_1959_Thumb_Big.jpg',
      },
    ],
  },
  {
    id: 'PR17',
    data: products.PR17,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'RT 20',
    year: '1961',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_RT20_1961_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1962',
  },
  {
    id: 'PR18',
    data: products.PR18,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Sixtant SM 31',
    year: '1962',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Sixtant_SM_31_1962_Thumb_Big.jpg',
  },
  {
    id: 'HD10',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD10,
    position: humanTitle.HD10,
    name: humanNames.HD10,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__DietrichLubs_1962_Thumb.jpg',
    between: [1962, 1995],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR20',
        data: products.PR20,
        name: 'HT 2',
        year: '1963',
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467107/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_HT2_1963_Thumb_Big.jpg',
      },
      {
        id: 'PR21',
        data: products.PR21,
        name: 'T 1000',
        year: '1963',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_T1000_1963_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR19',
        data: products.PR19,
        name: 'KSM 1/11',
        year: '1963',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun__KSM_1_1963_Thumb_Big.jpg',
      },
      {
        id: 'PR22',
        data: products.PR22,
        name: 'HLD 231',
        year: '1964',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_HLD_231_1964_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1968',
  },
  {
    id: 'PR24',
    data: products.PR24,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'PS 500',
    year: '1968',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_PS500_1968_Thumb_Big.jpg',
  },
  {
    id: 'HD11',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD11,
    position: humanTitle.HD11,
    name: humanNames.HD11,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__PeterHartwein_1970_Thumb.jpg',
    between: [1970, 2005],
  },
  {
    id: 'PR25',
    data: products.PR25,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'HLD 4',
    year: '1970',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_HLD_4_1970_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1972',
  },
  {
    id: 'PR30',
    data: products.PR30,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Phase 1',
    year: '1972',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Phase_1_1972_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR26',
        data: products.PR26,
        name: 'Intercontinental',
        year: '1972',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Intercontinental_1972_Thumb_Big.jpg',
      },
      {
        id: 'PR28',
        data: products.PR28,
        name: 'KF 20',
        year: '1972',
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467393/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_KF-20_1972_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR29',
        data: products.PR29,
        name: 'MPZ 22',
        year: '1972',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_MPZ_22_1972_Thumb_Big.jpg',
      },
      {
        id: 'PR27',
        data: products.PR27,
        name: 'BM 12 Lady Shaver',
        year: '1972',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_BM_12_Lady_Shaver_1972_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1973',
  },
  {
    id: 'HD12',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD12,
    position: humanTitle.HD12,
    name: humanNames.HD12,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__PeterSchneider_1973_Thumb.jpg',
    between: [1973, 2008],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR31',
        data: products.PR31,
        name: 'Functional',
        year: '1975',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Functional_1975_Thumb_Big.jpg',
      },
      {
        id: 'PR32',
        data: products.PR32,
        name: 'ET 33',
        year: '1977',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline__Braun_ET33_1977_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.MOMENT,
    id: 'EV07',
    name: momentTitle.EV07,
    year: '1977',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1599156204/max-braun/timeline/products/Braun_MaxBraun_Hero_Braun__10principles_1977_Thumb.png',
    data: moments.EV07,
  },
  {
    id: 'PR33',
    data: products.PR33,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'DW 30',
    year: '1978',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1601467605/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_DW30_1978_Thumb_Big.jpg',
  },
  {
    id: 'PR34',
    data: products.PR34,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Micron plus',
    year: '1979',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Micron_plus_1979_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1979',
  },
  {
    id: 'PR35',
    data: products.PR35,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Atelier',
    year: '1980',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Atelier_1980_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.ROOM_PREVIEW,
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_450/max-braun/rooms/room7080.jpg',
    url: '/timeline/roomInteraction/7080',
    data: rooms['7080'],
    roomPreviewId: '7080_1',
  },
  {
    type: ELEMENT_TYPE.ROOM,
    label: general.roomExplorer,
    action: general.tapToExplore,
    url: '/timeline/roomInteraction/7080',
    id: 'ROOM_7080_1',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR36',
        data: products.PR36,
        name: 'MR 6',
        year: '1981',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_MR_6_1981_Thumb_Big.jpg',
      },
      {
        id: 'PR37',
        data: products.PR37,
        name: 'ABW 41',
        year: '1981',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_ABW41_1981_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1982',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR38',
        data: products.PR38,
        name: 'PGS 1200',
        year: '1982',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_PGS_1200_1982_Thumb_Big.jpg',
      },
      {
        id: 'PR39',
        data: products.PR39,
        name: 'KF 40',
        year: '1984',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_KF_40_1984_Thumb_Big.jpg',
      },
    ],
  },
  {
    id: 'PR40',
    data: products.PR40,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'Lady Braun Elegance 2',
    year: '1985',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Lady_Braun_elegance_2_1985_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1987',
  },
  {
    id: 'PR41',
    data: products.PR41,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'AB 1',
    year: '1987',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_AB1_1987_Thumb_Big.jpg',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR42',
        data: products.PR42,
        name: 'AW 10',
        year: '1989',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_AW_10_1989_Thumb_Big.jpg',
      },
      {
        id: 'PR44',
        data: products.PR44,
        name: 'Silk-epil EE 300',
        year: '1995',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Epilator_1995_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '1996',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR43',
        data: products.PR43,
        name: 'Syncro System 7570',
        year: '1999',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Syncro_7570_1990_Thumb_Big.jpg',
      },
      {
        id: 'PR45',
        data: products.PR45,
        name: 'ThermoScan',
        year: '1999',
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467794/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_ThermoScan_1999_Thumb_Big.png',
      },
    ],
  },
  {
    id: 'HD13',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD13,
    position: humanTitle.HD13,
    name: humanNames.HD13,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__BenWilson_2003_Thumb.jpg',
    between: [2003, 2021],
  },
  {
    type: ELEMENT_TYPE.ROOM_PREVIEW,
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_450/max-braun/rooms/room9000.jpg',
    url: '/timeline/roomInteraction/9000',
    id: '9000',
    data: rooms['9000'],
    roomPreviewId: '9000',
  },
  {
    type: ELEMENT_TYPE.ROOM,
    label: general.roomExplorer,
    action: general.tapToExplore,
    year: '1999',
    url: '/timeline/roomInteraction/9000',
    id: 'ROOM_9000',
  },
  {
    id: 'HD14',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD14,
    position: humanTitle.HD14,
    name: humanNames.HD14,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__OliverGrabes_2009_Thumb.jpg',
    between: [2009, 2021],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '2010',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR46',
        data: products.PR46,
        name: 'BN0106',
        year: '2011',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Wristwatch_2011_Thumb_Big.jpg',
      },
      {
        id: 'PR47',
        data: products.PR47,
        name: 'Multiquick 9',
        year: '2013',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Hand_blender_2013_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR48',
        data: products.PR48,
        name: 'Series 9',
        year: '2014',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Series_9_2014_Thumb_Big.jpg',
      },
      {
        id: 'PR49',
        data: products.PR49,
        name: 'BN0171',
        year: '2014',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Wristwatch_2014_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.ROOM_PREVIEW,
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_450/max-braun/rooms/roompresent.jpg',
    url: '/timeline/roomInteraction/present',
    id: 'present',
    data: rooms.present,
    roomPreviewId: 'present',
  },
  {
    type: ELEMENT_TYPE.ROOM,
    label: general.roomExplorer,
    action: general.tapToExplore,
    year: '2015',
    url: '/timeline/roomInteraction/present',
    id: 'ROOM_present',
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '2015',
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR50',
        data: products.PR50,
        name: 'IPL Silk-expert Pro 5',
        year: '2015',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Silk-expert_Pro_5_2015_Thumb_Big.jpg',
      },
      {
        id: 'PR51',
        data: products.PR51,
        name: 'Silk-épil 9 Flex',
        year: '2018',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Silk-épils_9_2018_Thumb_Big.jpg',
      },
    ],
  },
  {
    id: 'HD15',
    type: ELEMENT_TYPE.DESIGNER,
    data: designers.HD15,
    position: humanTitle.HD15,
    name: humanNames.HD15,
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/designers/Braun_MaxBraun_Timeline_Braun__MarkusOrthey_2019_Thumb.jpg',
    between: [2019, 2021],
  },
  {
    type: ELEMENT_TYPE.PRODUCT_GROUP,
    products: [
      {
        id: 'PR52',
        data: products.PR52,
        name: 'Series 7',
        year: '2020',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Series_7_2020_Thumb_Big.jpg',
      },
      {
        id: 'PR53',
        data: products.PR53,
        name: 'LE 01',
        year: '2020',
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_LE01_2020_Thumb_Big.jpg',
      },
    ],
  },
  {
    type: ELEMENT_TYPE.YEAR,
    year: '2021',
  },
  {
    id: 'PR54',
    data: products.PR54,
    type: ELEMENT_TYPE.PRODUCT,
    name: 'X Shaver',
    year: '2021',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_ProjectX_2021_Thumb_Big.jpg',
  },
  {
    id: 'design_panel',
    type: ELEMENT_TYPE.DESIGN,
    mainText: general.goodDesign,
    words: [
      {
        item: general.simple,
        id: 'simple',
      },
      {
        item: general.useful,
        id: 'useful',
      },
      {
        item: general.build,
        id: 'build',
      },
    ],
  },
  {
    id: general.discover,
    type: ELEMENT_TYPE.DISCOVER,
    title: general.discoverTitle,
    subTitle: general.discoverSubTitle,
    elements: [
      {
        id: 'discover_left',
        name: 'Series 9',
        description: general.designEdition,
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Series_9_2014_Hero_copy.jpg',
        btnText: general.discover,
        url:
          'https://us.braun.com/en-us/male-grooming/shavers-for-men/series-9',
      },
      {
        id: 'discover_center',
        name: 'Silk-epil 9 Flex',
        description: general.designEdition,
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597909258/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_Silk-%C3%A9pil_s_9_2018_Hero_copy.jpg',
        btnText: general.discover,
        url:
          'https://us.braun.com/en-us/female-hair-removal/epilators/silk-epil-9-flex',
      },
      {
        id: 'discover_right',
        name: 'MGK 7',
        description: general.designEdition,
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/timeline/products/Braun_MaxBraun_Timeline_Braun_MGK_7_2019_Hero_copy.jpg',
        btnText: general.discover,
        url:
          'https://us.braun.com/en-us/male-grooming/stylers-and-trimmers/all-in-one-trimmers/all-in-one-trimmer-7-mgk7221',
      },
    ],
  },
];
